import { Form, Radio } from 'antd';
import { lazy, FC, useEffect } from 'react';
import './index.css';
import { useQuizFormContext } from '../../hooks/quiz-form-context';
import InputDescription from '../quiz-input-show-description/quiz-input-show-description';


const SelectionInput = ({
  title,
  name,
  description,
  Error,
  questionValueOptions = [],
  indexKey,
  allInputOnchageHandler,
  questionTooltip
}) => {
  const {
    formValues,
    allFormErrorsList,
    setFormValues,
    contentFullErrorMsg,
    setContentFulErrorMsg,
    getInputValues,
  } = useQuizFormContext();

  //  ONCHANGE FUNCTION
  function handleInputChange(e, fieldItem) {
    const { name, value } = e.target;
    if (fieldItem) {
      if (fieldItem.fields?.outcome) {
        allInputOnchageHandler(
          indexKey,
          title,
          name,
          value,
          fieldItem.sys.id,
          fieldItem.fields?.outcome?.sys.id,
          fieldItem.fields?.override,
        );
      } else {
        allInputOnchageHandler(indexKey, title, name, value, fieldItem.sys.id);
      }
    } else {
      allInputOnchageHandler(indexKey, title, name, value);
    }
  }

  //TO RENDER DESCRIPTION OF INPUTS
  function ShowDescription(description) {
    return <InputDescription description={description} questionTooltip={questionTooltip} />;
  }

  //Storing error msg value in state
  useEffect(() => {
    if (Error) {
      setContentFulErrorMsg((prev) => ({ ...prev, [name]: Error }))
    }
  }, [Error])

  return (
    <>
      <Form.Item
        label={description && ShowDescription(description)}
        name={name}
        className="input-label-container"
        required={Error ? true : false}
      >
        <Radio.Group name={name} className="selection-input-container">
          {questionValueOptions.map((fieldItem) => {
            return (
              <Radio.Button
                key={fieldItem.sys.id}
                value={fieldItem.fields?.value}
                className={
                  fieldItem.fields?.value === getInputValues(name, formValues)?.value
                    ? 'input-selection ant-radio-button-wrapper-checked'
                    : 'input-selection'
                }
                onChange={(e) => handleInputChange(e, fieldItem)}
              >
                <span className="input-content-text">{fieldItem.fields?.value}</span>
              </Radio.Button>
            );
          })}
        </Radio.Group>
      </Form.Item>
      {allFormErrorsList[name] && <span className="error-message">{Error}</span>}
    </>
  );
};

export default SelectionInput;
